(function () {
  function initSearchFilters(root) {
    root.querySelectorAll('[data-filter-form]').forEach(function (form) {
      let debounceTimer;
      form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        input.addEventListener('change', function () {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function () {
            form.submit();
          }, 500);
        });
      });
    });
  }

  function initFilterDrawer(root) {
    const openBtn = root.querySelector('[data-filter-drawer-open]');
    const closeBtn = root.querySelector('[data-filter-drawer-close]');
    const backdrop = root.querySelector('[data-filter-drawer-backdrop]');
    const drawer = root.querySelector('[data-filter-drawer]');

    if (!openBtn || !drawer) return;

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.removeAttribute('inert');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('filters-drawer-open');
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('filters-drawer-open');
    }

    close();
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  function initQuickAdd(root) {
    root.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        btn.disabled = true;
        btn.classList.add('is-loading');

        // Theme cart API handles popup + mini-cart (cart:refresh does not exist here)
        if (typeof Shopify !== 'undefined' && typeof Shopify.addItem === 'function') {
          Shopify.addItem(variantId, 1);
          setTimeout(function () {
            btn.disabled = false;
            btn.classList.remove('is-loading');
          }, 1500);
          return;
        }

        var addUrl =
          window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart/add.js'
            : '/cart/add.js';

        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(variantId) || variantId, quantity: 1 }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add failed');
            return res.json();
          })
          .then(function () {
            if (typeof Shopify !== 'undefined' && typeof Shopify.getCart === 'function') {
              Shopify.getCart();
            }
          })
          .catch(function () {
            var form = document.createElement('form');
            form.method = 'POST';
            form.action = '/cart/add';
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'id';
            input.value = variantId;
            form.appendChild(input);
            document.body.appendChild(form);
            form.submit();
          })
          .finally(function () {
            btn.disabled = false;
            btn.classList.remove('is-loading');
          });
      });
    });
  }

  function initViewToggle(root) {
    const container = root.querySelector('[data-results-container]');
    const toggles = root.querySelectorAll('[data-view-toggle]');
    if (!container || !toggles.length) return;

    const saved = localStorage.getItem('searchViewMode');
    if (saved === 'list') {
      container.classList.remove('grid-view');
      toggles.forEach(function (b) {
        b.classList.toggle('active', b.dataset.view === 'list');
      });
    } else {
      container.classList.add('grid-view');
      toggles.forEach(function (b) {
        b.classList.toggle('active', b.dataset.view === 'grid');
      });
    }

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const view = btn.dataset.view;
        toggles.forEach(function (b) {
          b.classList.toggle('active', b === btn);
        });
        container.classList.toggle('grid-view', view === 'grid');
        localStorage.setItem('searchViewMode', view);
      });
    });
  }

  function initSort(root) {
    const select = root.querySelector('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      const url = new URL(window.location.href);
      if (select.value === 'relevance' || select.value === '') {
        url.searchParams.delete('sort_by');
      } else {
        url.searchParams.set('sort_by', select.value);
      }
      window.location.href = url.toString();
    });
  }

  document.querySelectorAll('[data-search-page]').forEach(function (page) {
    initSearchFilters(page);
    initFilterDrawer(page);
    initQuickAdd(page);
    initViewToggle(page);
    initSort(page);
  });
})();
